import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock } from 'lucide-react';
export function Proof() {
  return <section className="bg-kitchen-cream py-12 md:py-20 px-5 md:px-12 lg:px-24" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <FadeIn data-id="element-127">
          <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-12 shadow-xl border border-kitchen-amber/20 relative overflow-hidden" data-id="element-128">
            {/* Decorative element */}
            <div className="absolute top-0 right-0 w-24 md:w-32 h-24 md:h-32 bg-kitchen-amber/10 rounded-bl-full -z-0" data-id="element-129"></div>

            <div className="relative z-10" data-id="element-130">
              <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8" data-id="element-131">
                <div className="bg-kitchen-terracotta/10 p-2 md:p-3 rounded-full" data-id="element-132">
                  <Clock className="w-6 h-6 md:w-8 md:h-8 text-kitchen-terracotta" data-id="element-133" />
                </div>
                <h2 className="font-lora text-xl md:text-3xl font-bold text-kitchen-brown" data-id="element-134">
                  El Sistema de 48 Horas ⏱️
                </h2>
              </div>

              <div className="space-y-4 md:space-y-6 font-nunito text-base md:text-xl text-kitchen-brown/90 leading-relaxed" data-id="element-135">
                <p data-id="element-136">Este no es un libro de teoría. Es un sistema de 48 horas.</p>
                <div className="pl-5 md:pl-6 border-l-4 border-kitchen-amber space-y-3 md:space-y-4 py-2" data-id="element-137">
                  <p data-id="element-138">
                    <strong data-id="element-139">El día 1</strong> lanzas tu mensaje siguiendo el
                    guion.
                  </p>
                  <p data-id="element-140">
                    <strong data-id="element-141">El día 2</strong> entregas 10 platos.
                  </p>
                </div>
                <p className="font-bold text-kitchen-green text-lg md:text-2xl pt-2 md:pt-4" data-id="element-142">
                  Al terminar la tarde, tienes $150 dólares en efectivo.
                </p>
                <p data-id="element-143">
                  Recuperas tu inversión inicial y te quedan más de $110 libres
                  para tu familia. Lo que antes te tomaba una semana ganar
                  limpiando, ahora lo haces en una mañana de trabajo desde casa.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}